// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../apps/user-management/users-list/table/columns/UserCustomHeader'
import {ReturnScrapRecord} from './api'

const getReturnScrapColumns = (): ReadonlyArray<Column<ReturnScrapRecord>> => [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Product'
        className='min-w-150px ps-4 text-center'
      />
    ),
    id: 'productName',
    accessor: 'productName',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='SKU Code' className='min-w-100px text-center' />
    ),
    accessor: 'skuCode',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Return Qty' className='min-w-100px text-center' />
    ),
    accessor: 'returnQty',
    sortType: 'basic',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Scrap Qty' className='min-w-100px text-center' />
    ),
    accessor: 'scrapQty',
    sortType: 'basic',
    Cell: ({...props}) => (
      <span className='text-danger fw-bold'>{props.data[props.row.index].scrapQty}</span>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Total Value'
        className='min-w-125px text-center'
      />
    ),
    accessor: 'totalValue',
    sortType: 'basic',
    Cell: ({...props}) => (
      <span className='text-primary fw-bold'>&#8377; {props.data[props.row.index].totalValue}</span>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Date' className='min-w-125px text-center' />
    ),
    accessor: 'date',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='UOM' className='min-w-70px text-center' />
    ),
    accessor: 'unit',
    sortType: 'string',
    Cell: ({...props}) => (
      <span className='badge badge-light-dark fw-bold'>{props.data[props.row.index].unit}</span>
    ),
  },
]

export {getReturnScrapColumns}
